export const ratingOptions = [
  { value: 'red', label: 'Rot', key: '1' },
  { value: 'yellow', label: 'Gelb', key: '2' },
  { value: 'green', label: 'Grün', key: '3' },
  { value: 'final', label: 'Final', key: '4' }
];

export default function RatingSelector({ value, onChange, compact = false }) {
  return (
    <div className={compact ? 'rating-selector rating-selector--compact' : 'rating-selector'}>
      {ratingOptions.map((option) => (
        <button
          className={value === option.value ? `rating-chip ${option.value} is-active` : `rating-chip ${option.value}`}
          type="button"
          key={option.value}
          onClick={() => onChange(value === option.value ? null : option.value)}
          title={`${option.key} = ${option.label}`}
        >
          <span />
          {option.label}
        </button>
      ))}
    </div>
  );
}
